import * as React from 'react';
const SvgVirtual = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M116.193 60.065v42.58M7.807 102.645v-63.87a7.74 7.74 0 0 1 7.742-7.743h32.903M110.387 122H13.613C7.202 122 2 116.798 2 110.387h46.452v3.871h27.096v-3.871H122c0 6.411-5.197 11.613-11.613 11.613ZM45.62 77.484c4.564-3.044 4.143-4.994 4.685-9.421.29-2.39.382-4.96-.77-7.152-1.055-2.008-2.995-3.396-5.11-4.113a11.706 11.706 0 0 0-7.432 0c-2.119.717-4.055 2.105-5.11 4.113-1.151 2.192-1.064 4.766-.769 7.152.542 4.422.121 6.377 4.684 9.42M63.935 100.71v-3.871c0-3.871-1.935-5.807-5.806-7.742l-7.742-3.871s-3.87 1.935-9.677 1.935c-5.807 0-9.678-1.935-9.678-1.935l-7.742 3.87c-3.87 1.936-5.806 3.872-5.806 7.743v3.871M118.129 48.452h-38.71L60.065 62V5.871A3.87 3.87 0 0 1 63.934 2h54.194A3.87 3.87 0 0 1 122 5.871v38.71a3.87 3.87 0 0 1-3.871 3.87ZM75.548 19.42h30.968M75.548 31.032h15.484"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgVirtual;
